import React from 'react';

import ImportHistory from '../../components/Admin/ImportHistory';

function ImportHistoryView() {
  return (
    <ImportHistory />
  );
}

export default ImportHistoryView;


